import {JsonProperty} from '../../../../core/src/lib/core/utils/decorators/json-convert';
import {User} from '../../../../core/src/lib/login/data/user';
import {DateConverter} from '../../../../core/src/lib/core/utils/json/date-converter';
import {AbstractModel, JsonObject} from '../../../../core/src/public-api';

@JsonObject('model.InstallationQuote')
export class InstallationQuote extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(Number, 'jobId')
  jobId?: number;

  @JsonProperty(String, 'jobName')
  jobName?: string;

  @JsonProperty(String, 'jobNumber')
  jobNumber?: string;

  @JsonProperty(Number, 'price')
  price?: number;

  @JsonProperty(User, 'addressee')
  addressee?: User;

  @JsonProperty(String, 'clazz')
  clazz?: string;

  @JsonProperty(Number, 'addresseeId')
  addresseeId?: number;

  @JsonProperty(String, 'addresseeName')
  addresseeName?: string;

  @JsonProperty(DateConverter, 'awardSent')
  awardSent?: Date;

  @JsonProperty(DateConverter, 'createdTime')
  createdTime?: Date;

  @JsonProperty(DateConverter, 'installationDate')
  installationDate?: Date;

  @JsonProperty(DateConverter, 'sentDate')
  sentDate?: Date;

  @JsonProperty(String, 'statusTitle')
  statusTitle?: string;

  code?: string
}
